import { ApolloError } from '@apollo/client';
import { createAsyncThunk } from '@reduxjs/toolkit';

interface MarkMessagesAsUnreadResponse {
  success?: boolean;
  error?: ApolloError | undefined;
  messageUids?: number[];
  mailboxId?: string;
}

interface MarkMessagesArg {
  payload: {
    mailboxId: string;
    messageUids: number[];
  };
  markMessagesUnreadHook: any;
}

export const markMessagesUnreadThunk = createAsyncThunk(
  'markMessagesUnread',
  async (arg: MarkMessagesArg): Promise<MarkMessagesAsUnreadResponse> => {
    try {
      const response = await arg.markMessagesUnreadHook({
        variables: {
          mailboxId: arg.payload.mailboxId,
          messageUids: arg.payload.messageUids,
        },
      });
      return {
        success: response?.data?.markMessagesUnseen.success || false,
        messageUids: arg.payload.messageUids,
        mailboxId: arg.payload.mailboxId,
      };
    } catch (e) {
      return {
        error: e as ApolloError,
      };
    }
  }
);
